module.exports = __webpack_public_path__ + "Lato-BlackItalic.798eafdd87dc8f3174f7.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-BlackItalic.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-BlackItalic.woff
// module chunks = styles